'use client';

import cx from 'classnames';
import NextLink from 'next/link';
import { AnchorHTMLAttributes, ReactNode, Ref, createElement } from 'react';

import { ShapeType } from '../Button';
import styles from '../Button/button.module.scss';
import { Spinner } from '../Spinner';
import { SizeType } from '../types/base';

interface DynamicLinkTagProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'prefix' | 'href'> {
  href: string;
  className?: string;
  opener?: boolean;
  replace?: boolean;
  external?: boolean;
  isFull?: boolean;
  children: ReactNode;
  aTagRef?: Ref<HTMLAnchorElement | null>;
}

/**
 * @deprecated
 * react >> IsomorphicLink
 */
export const DynamicLinkTag = ({ href, external, opener, children, aTagRef, ...props }: DynamicLinkTagProps) => {
  return createElement(
    external ? 'a' : NextLink,
    {
      href,
      ...props,
      ...(opener ? { target: '_blank', rel: 'noopener' } : undefined),
      ref: aTagRef,
    },
    children,
  );
};

interface Props extends DynamicLinkTagProps {
  size?: SizeType;
  shape?: ShapeType;
  prefix?: ReactNode;
  suffix?: ReactNode;
  underline?: boolean;
  loading?: boolean;
}

export const Link = ({
  size = 'large',
  shape = 'link1',
  href,
  children,
  prefix,
  suffix,
  underline,
  className,
  isFull,
  loading,
  external = false,
  opener,
  replace,
  aTagRef,
  ...restProps
}: Props) => {
  return (
    <DynamicLinkTag
      href={href}
      className={cx(styles.wrapper, styles[size], styles[shape], className, {
        [styles.underline]: underline,
        [styles.isFull]: isFull,
      })}
      opener={opener}
      external={external}
      replace={replace}
      aTagRef={aTagRef}
      {...restProps}
    >
      {loading ? (
        <Spinner size='small' />
      ) : (
        <>
          {prefix}
          {children}
          {suffix}
        </>
      )}
    </DynamicLinkTag>
  );
};
